import { useState, useEffect } from 'react';
import { getOffices } from './services/officeAPIs';

export const useOffices = () => {
  const [offices, setOffices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOffices = async () => {
      try {
        setLoading(true);
        const officeData = await getOffices();
        setOffices(Array.isArray(officeData) ? officeData : []);
        setError(null);
      } catch (err) {
        console.error('Error fetching offices in useOffices hook:', err);
        setError(err.message || 'Failed to fetch offices');
      } finally {
        setLoading(false);
      }
    };
    fetchOffices();
  }, []);

  return { offices, setOffices, loading, error };
};

